const klaviyoJS = {};

/**
 * Sets up Klaviyo event listeners.
 */
function klaviyoListeners() {
    for (const element of klaviyoJS.emailFieldSelectors) {
        const $selectedInput = $(element);
        if ($selectedInput.length) {
            $selectedInput.each(function () {
                const input = this;
                if (input && !input.hasAttribute('data-listener')) {
                    input.setAttribute('data-listener', 'klaviyo');
                    input.addEventListener('change', klaviyoChangeEvent);
                }
            });
        }
    }
}

/**
 * Handles the change event for Klaviyo input fields.
 *
 * @param {Event} input - The input event.
 */
function klaviyoChangeEvent(input) {
    if (!klaviyoJS.identifiedUser || (input.target.value && input.target.value !== klaviyoJS.email)) {
        klaviyoJS.phoneOrEmail(input);
    }
    if (input.target.pattern.length && input.target.value.match(input.target.pattern)) {
        if (klaviyoJS.identifiedUser && klaviyoJS.exchangeID && klaviyoJS.phone) {
            window.klaviyo
                .identify({
                    $email: input.target.value,
                    $phone_number: klaviyoJS.phone
                })
                .then(() => {
                    klaviyoJS.identifiedUser = true;
                    klaviyoJS.exchangeID = klaviyoJS.getExchangeID();
                });
        }
    } else if (
        klaviyoJS.identifiedUser &&
        klaviyoJS.exchangeID &&
        klaviyoJS.phone &&
        klaviyoJS.sfccEmailRegex.test(input.target.value)
    ) {
        window.klaviyo
            .identify({
                $email: input.target.value,
                $phone_number: klaviyoJS.phone
            })
            .then(() => {
                klaviyoJS.identifiedUser = true;
                klaviyoJS.exchangeID = klaviyoJS.getExchangeID();
            });
    }
}

/**
 * trigger Klaviyo page tracking event
 */
function pageEventTrack() {
    const $pageEventTracker = $('.js-klaviyo-page-event-tracker');
    const action = $pageEventTracker.data('klaviyo-action');
    const dataObj = $pageEventTracker.data('klaviyo-event-data');

    if (!action || !dataObj) {
        return;
    }

    window.klaviyo.push(['track', action, dataObj]);
}

/**
 * Initializes the HubBox component and sets up event listeners.
 */
function init() {
    const $klaviyoDataJSON = $('#klaviyo-listeners-data');

    if (!$klaviyoDataJSON.length) {
        // Klaviyo is disabled
        return;
    }

    klaviyoJS.sfccEmailRegex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    klaviyoJS.e164PhoneRegex = /^\+[1-9]\d{1,14}$/;

    const klaviyoData = JSON.parse($klaviyoDataJSON.text());

    if (klaviyoData.KLCheckoutSelector) {
        const $selectedInput = $(klaviyoData.KLCheckoutSelector);
        if ($selectedInput.length) {
            $selectedInput.each(function () {
                const $klavInput = $(this);
                $klavInput.on('change', function () {
                    if (klaviyoJS.sfccEmailRegex.test($klavInput.val())) {
                        $.ajax({
                            url: klaviyoData.StartedCheckoutEventURL,
                            type: 'post',
                            data: {a: btoa($klavInput.val())},
                            // eslint-disable-next-line jsdoc/require-jsdoc
                            error(err) {
                                console.warn(`Klaviyo StartedCheckoutEvent failure: ${err.statusText}`);
                            }
                        });
                    }
                });
            });
        }
    }

    if (klaviyoData.KLCheckoutSelector || klaviyoData.KLSelectors.length) {
        const KLselectors = klaviyoData.KLSelectors;
        klaviyoJS.emailFieldSelectors = Array.isArray(KLselectors) ? KLselectors : Object.values(KLselectors);
        if (klaviyoData.KLCheckoutSelector) {
            KLselectors.push(klaviyoData.KLCheckoutSelector);
        }
        /**
         * Retrieves the exchange ID from the Klaviyo cookie.
         *
         * @returns {string} The exchange ID.
         */
        klaviyoJS.getExchangeID = function () {
            const klaviyoCookie = document.cookie.split('; ').filter(function (c) {
                return /__kla_id=/.test(c);
            });
            return JSON.parse(atob(klaviyoCookie[0].split('__kla_id=')[1])).$exchange_id;
        };
        /**
         * Identifies the user by phone number.
         *
         * @param {string} inputVal - The input value.
         */
        klaviyoJS.identifyPhone = function (inputVal) {
            const formattedPhone = `+${inputVal.replace(/[^a-z0-9]/gi, '')}`;
            if (klaviyoJS.e164PhoneRegex.test(formattedPhone)) {
                window.klaviyo.identify({$phone_number: formattedPhone}).then(() => {
                    klaviyoJS.identifiedUser = true;
                    klaviyoJS.exchangeID = klaviyoJS.getExchangeID();
                    klaviyoJS.phone = formattedPhone;
                });
            }
        };
        /**
         * Identifies the user by phone number or email.
         *
         * @param {Event} inputVal - The input event.
         */
        klaviyoJS.phoneOrEmail = function (inputVal) {
            if (klaviyoJS.sfccEmailRegex.test(inputVal.target.value)) {
                window.klaviyo.identify({$email: inputVal.target.value}).then(() => {
                    klaviyoJS.identifiedUser = true;
                    klaviyoJS.email = inputVal.target.value;
                    klaviyoJS.exchangeID = klaviyoJS.getExchangeID();
                });
            }
            if (Number(inputVal.target.value.replace(/[^a-z0-9]/gi, ''))) {
                klaviyoJS.identifyPhone(inputVal.target.value);
            }
        };
        Promise.resolve(window.klaviyo.isIdentified()).then(result => {
            klaviyoJS.identifiedUser = result;
        });

        if ('MutationObserver' in window) {
            const page = document.body;
            const observer = new MutationObserver(() => {
                klaviyoListeners();
            });

            observer.observe(page, {
                childList: true,
                subtree: true
            });
        }

        klaviyoListeners();
    }

    if (klaviyoData.KLEmailListID) {
        /**
         * Subscribes the user to Klaviyo.
         *
         * @param {Object} data - The subscription data.
         */
        klaviyoJS.subscribe = function (data) {
            $.ajax({
                url: klaviyoData.SubscribeURL,
                type: 'post',
                data,
                // eslint-disable-next-line jsdoc/require-jsdoc
                error(err) {
                    console.warn(`Klaviyo Subscribe failure: ${err.statusText}`);
                }
            });
        };

        klaviyoJS.emailSubscribe = document.getElementById('dwfrm_singleshipping_subscribeToNL');
        if (klaviyoJS.emailSubscribe) {
            if (klaviyoJS.emailSubscribe.checked) {
                klaviyoJS.subscribe({e: true});
            }
            klaviyoJS.emailSubscribe.addEventListener('click', function () {
                klaviyoJS.subscribe({e: klaviyoJS.emailSubscribe.checked});
            });
        }
    }

    pageEventTrack();
}

module.exports.init = init;
